<template>
    <div class="gift-ideas-container">
        <div class="top-white-box"></div>
        <div class="gift-ideas-loading" v-show="isLoading">
            <button :disabled="true">
                <span class="icon"><img src="/Assets/img/spin.svg" /></span>
            </button>
            <div>Loading</div>
        </div>
        <div class="gift-ideas-list-title" v-if="!isClean && articleDetails"><h1>{{articleDetails.title}}</h1></div>
        <div class="gift-ideas-list-img" v-if="!isClean && articleDetails"><img :src="articleDetails.imgUrl" alt="articleDetails.title" /></div>
        <div class="gift-ideas-list-desc" v-if="!isClean && articleDetails">{{articleDetails.desc}}</div>
        <div v-if="articleDetails" class="article-deals-container">
            <Deals :listOfDeals="articleDetails.deals"></Deals>
        </div>

        <div class="top-gray-box" v-if="articleDetails">
            <h1>Other Gift Ideas You Might Like</h1>
        </div>
        <Articles :excludeArticles="$route.params.id" v-if="articleDetails" />
    </div>
</template>


<script>
    // @ is an alias to /src
    import api from '@/api'
    import settings from '@/settings'
    import Articles from "@/components/Articles.vue";
    import Deals from "@/components/Deals.vue";
    


    export default {
        name: "giftlist",
        data() {
            return {
                isParticipant: false,
                isLoading: false,
                articleDetails: null,
                articleUrl: null,
                linkToJoinWhatsAppGroup: settings.socialLinks.whatsapp,
                isClean: false
            };
        },
        components: {
            Articles,
            Deals
        },
        methods: {
            init() {
                this.isLoading = true;
                this.articleId = this.$route.params.id;
                this.articleDetails = null;
                

                

                api.getArticleDetails(this.articleId, true).then(response => {
                    //console.log("getArticleDetails response", response);
                    var responseData = response.data;
                    let tmpArticleDetails = response.data;
                    tmpArticleDetails.imgUrl = 'https://' + settings.siteUrl + tmpArticleDetails.imgUrl;

                    this.articleDetails = responseData;
                    
                    this.isLoading = false;
                    document.title = this.articleDetails.pageTitle + ' | ' + settings.siteNameCaps; 

                });
            }
        },
        created() {
            var cookie_lastref = this.$cookie.get('MMD_ParticipantRefCode');
            if (cookie_lastref) {
                this.isParticipant = true;
            }

            if (this.$route.query.direct)
                this.isClean = true;
            else
                this.isClean = false;

            this.init();


        }

    };
</script>
